import styled from 'styled-components';
import { media } from 'style';

export default {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${media.sm`
      flex-direction: row;
      justify-content: space-between;
    `}
  `,
  TextContainer: styled.div`
    max-width: 600px;
  `,
  Title: styled.div`
    margin-bottom: 10px;
  `,
  Text: styled.div``,
  ImageContainer: styled.div`
    flex-grow: 1;
    display: flex;
    justify-content: center;
  `,
  Image: styled.img`
    display: none;
    ${media.sm`
       display: block;
       margin-left: 20px;
    `}
  `,
  MobileImage: styled.img`
    display: block;
    margin-top: 20px;
    max-width: 350px;
    width: 100%;

    ${media.sm`
       display: none;
    `}
  `,
};
